import { getDataList, getSEO } from '@/api/api';

export default {
  namespaced: true,
  state: {
    FootballList: {}, // 源数据
    FootballSortMatch: {}, // 排序后的数据
    LeagueList: {}, // 渲染数据
    FootballMatch: {}, // 全部比赛数据
    SEO:{}
  },
  mutations: {
    setFootballList: (state, data) => {
      state.FootballList = data;
    },
    setFootballSortMatch: (state, data) => {
      state.FootballSortMatch = data;
    },
    setLeagueList: (state, data) => {
      state.LeagueList = data;
    },
    setFootballMatch: (state, data) => {
      state.FootballMatch = data;
    },
    setHotLeague: (state, data) => {
      state.hotLeague = data;
    },
    setMyLeague: (state, data) => {
      state.myLeague = data;
    },
    setSEO: (state, data) => {
      state.SEO = data;
    },
  },
  actions: {
    fetchDataList({ commit, state }, params) {
      return new Promise((resolve, reject) => {
          getDataList(params).then(response => {
              if (response) {
                  commit('setFootballList', response)
              }
              resolve(response)
          }).catch(error => {
              reject(error)
          })
      })
    },

    fetchSEO({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        getSEO(params).then((response) => {
          let _data = JSON.parse(JSON.stringify(response.data));
          commit('setSEO', _data)
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/home.js